export default {
    upload: state => state.upload
};
